var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.slides && _vm.slides.length)?_c('section',{staticClass:"marketing-message show-on-load relative overflow-hidden",attrs:{"aria-label":"Marketing Message"}},[_c(_vm.templateComponent,{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }